import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * Modal reutilizable con estilos modernos consistentes y tamaño estándar
 * 
 * @param {boolean} isOpen - Si el modal está abierto
 * @param {function} onClose - Callback para cerrar el modal
 * @param {string} title - Título del modal
 * @param {object} icon - Objeto de icono FontAwesome (ej: faArchive de @fortawesome/free-solid-svg-icons)
 * @param {node} children - Contenido del modal
 */
const Modal = ({ 
  isOpen, 
  onClose, 
  title, 
  icon, 
  children
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modern-modal modal-standard" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-header-content">
            {icon && (
              <div className="modal-header-icon">
                <FontAwesomeIcon icon={icon} />
              </div>
            )}
            <h3>{title}</h3>
          </div>
          <button
            className="close-button"
            onClick={onClose}
            type="button"
          >
            <i className="fa fa-times"></i>
          </button>
        </div>
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;

